'use client'

import { HTMLProps, useState } from 'react'
import clsx from 'classnames'
import { motion } from 'framer-motion'
import { useMediaQuery } from 'usehooks-ts'
import { useTranslations } from 'next-intl'
import { Button, Text } from '@/shared/ui'
import { InstitutionItem } from '@/shared/ui/institution-item'
import { IInstitution } from '@/interfaces/institutions'

import { useAppearance } from '@/shared/utils'
import { variantsHeadline } from '@/shared/constants/variants'
import style from './institutions.module.scss'

interface ParticipantsProps extends HTMLProps<HTMLDivElement> {
  title: string
  items: IInstitution[]
}

export const Institutions = (props: ParticipantsProps) => {
  const { className, title, items } = props
  const translate = useTranslations()
  const { ref: innerRef, animate } = useAppearance()
  const isMobile = useMediaQuery('(max-width: 600px)')
  const [showAll, setShowAll] = useState(false)
  const toggleShowAll = () => {
    setShowAll(prev => !prev)
  }

  return (
    <motion.section
      ref={innerRef}
      animate={animate}
      variants={variantsHeadline}
      className={clsx(style.container, 'white-section-without-paddings', className)}
    >
      <Text className={style.title} color="dark" type="h2" tagName="h3">
        {title}
      </Text>

      <ul className={clsx(style.list)}>
        {items.slice(0, isMobile ? (showAll ? items.length : 3) : items.length).map((item, index) => (
          <InstitutionItem className={style.item} key={index} {...item} />
        ))}
      </ul>

      {isMobile && (
        <div className={clsx(style.btnContainer)}>
          <Button type="outline" className={style.button} onClick={toggleShowAll}>
            {showAll ? translate('hide') : translate('buttonViewAll')}
          </Button>
        </div>
      )}
    </motion.section>
  )
}
